import { Component } from '@angular/core';

@Component({
  selector: 'app-amenity-task-create',
  template: ``,
  styleUrls: []
})
export class AmenityTaskCreateComponent {

}
